<template>
    <v-app-bar app color="primary" class="text-left" clippedLeft>
        <v-img v-if="user.logo_url != ''" :src="user.logo_url" max-height="40" contain position="left center" />
        <v-spacer></v-spacer>
        <v-menu offset-y v-if="!phone_numbers.loading && phone_numbers.numbers.length > 0">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" text v-on="on">
                    <v-icon>
                        mdi-phone
                    </v-icon>
                    <span v-if="user && user.current_phone_number">{{user.current_phone_number.friendly_name}}</span>
                    <span v-else>Select Phone Number</span>
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="phone_number in phone_numbers.numbers" :key="phone_number.sid" @click="user.saveCurrentPhoneNumber(phone_number)">
                    <v-list-item-title class="">{{phone_number.friendly_name}}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-btn v-else-if="phone_numbers.loading" icon loading>
            <v-icon>
                mdi-loading
            </v-icon>
        </v-btn>
        <!-- <v-btn @click="app.logOut()" x-small text>Log Out</v-btn> -->


        <!-- BM: SNACKBAR ALERTS -->
        <v-snackbar 
            :centered="!!app.snackbar.settings.centered" 
            :color="app.snackbar.settings.color" 
            v-model="app.snackbar.settings.show" 
            :top="!!app.snackbar.settings.top" 
            :timeout="app.snackbar.timeout"
        >
            {{app.snackbar.settings.message}}
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    @click="app.snackbar.settings.show = false"
                >
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </template>
        </v-snackbar>


        <!-- BM: LOGIN DIALOG -->
        <v-dialog
            v-model="app.show_login_dialog"
            width="500"
            persistent
            overlay-opacity="1"
            >
            <v-card>
                <v-card-title class="text-h5 primary">
                    <v-icon class="mr-2">mdi-lock</v-icon>
                    Account Login
                </v-card-title>

                <v-card-text class="px-6 pt-6 pb-0">
                    <v-alert v-model="app.show_login_error" color="error" text icon="mdi-alert-circle">Login failed</v-alert>
                    <p>Please log in:</p>
                    <v-text-field label="Email" outlined v-model="login.email"></v-text-field>
                    <v-text-field label="Password" type="password" outlined v-model="login.password"></v-text-field>
                </v-card-text>

                <v-card-actions class="px-6 pb-6 pt-0 mt-0">
                    <v-btn text color="grey" x-small>Forgot Password</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="app.doLogin(login.email, login.password)"
                        :loading="app.is_logging_in"
                        :disabled="app.is_logging_in"
                    >
                        Login
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="app.show_app_overlay" opacity="1">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <div>{{app.app_overlay_text}}</div>
        </v-overlay>

    </v-app-bar>
</template>

<script>
import { useUserStore } from "../stores/user"
import { usePhoneNumbersStore } from "../stores/phone_numbers"
import { useAppStore } from "../stores/app"
import axios from 'axios'

export default {
	name: 'SystemBar',
    created() {
        this.user = useUserStore()
        this.phone_numbers = usePhoneNumbersStore()
        this.app = useAppStore()

		this.user.fetchUser()
        this.phone_numbers.fetchPhoneNumbers()
	},
    data: () => {
        return {
            user: null,
            phone_numbers: null,
            app: null,
            login: {
                email: "",
                password: ""
            },
            // is_logging_in: false,
            // show_login_error: false,
            // check_login_interval: null
        }
    },
    mounted: function() {
        this.app.createInterval()
        this.app.getUnreadMessages()
        this.app.getTasks()
        // this.app.subscribe()
    },
    methods: {
        
    }
}

</script>

<style scoped>
.v-list-item {
	cursor: pointer;
}
</style>
